// =====================================================================================
// INVRT Radar — web console — Stripe checkout return (cancelled)
//
// Stripe redirects here (the cancel_url the Credits tab sent on POST /v1/packs/checkout)
// when a person backs out of card payment before it completes. Nothing was charged and
// nothing needs undoing — this page exists purely to land the browser somewhere sensible
// and point back at the Credits tab.
// =====================================================================================

import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { buttonVariants } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function CheckoutCancelledPage() {
  return (
    <div className="mx-auto flex max-w-lg flex-col items-center gap-6 py-12 text-center">
      <Card className="w-full">
        <CardHeader className="items-center text-center">
          <XCircle className="h-8 w-8 text-ink-faint" aria-hidden="true" />
          <CardTitle>Purchase cancelled</CardTitle>
          <p className="mt-1 text-sm text-ink-muted">
            Nothing was charged and your balance has not changed.
          </p>
        </CardHeader>
        <CardContent>
          <Link to="/account?tab=credits" className={buttonVariants({ variant: "primary" })}>
            Back to credits
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
